module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<div class="netsim-my-device-tab">\n\n  <% if (locals.level.showMetronome) { %>\n    <div class="metronome"></div>\n  <% } %>\n\n  <% if (locals.level.showPulseRateSlider) { %>\n    <h1>Pulse rate</h1>\n    <div class="pulse-rate"></div>\n  <% } %>\n\n  <% if (locals.level.showBitRateControl) { %>\n    <h1>Bitrate</h1>\n    <div class="bitrate"></div>\n  <% } %>\n\n  <% if (locals.level.showChunkSizeControl) { %>\n    <h1>Chunk size</h1>\n    <div class="chunk-size"></div>\n  <% } %>\n\n  <% if (locals.level.showEncodingControls.length > 0) { %>\n    <div class="encoding"></div>\n  <% } %>\n\n</div>\n', __filename = "src/netsim/NetSimMyDeviceTab.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __append('<div class="netsim-my-device-tab">\n\n  ');
            __line = 3;
            if (locals.level.showMetronome) {
                __append('\n    <div class="metronome"></div>\n  ');
                __line = 5;
            }
            __append("\n\n  ");
            __line = 7;
            if (locals.level.showPulseRateSlider) {
                __append('\n    <h1>Pulse rate</h1>\n    <div class="pulse-rate"></div>\n  ');
                __line = 10;
            }
            __append("\n\n  ");
            __line = 12;
            if (locals.level.showBitRateControl) {
                __append('\n    <h1>Bitrate</h1>\n    <div class="bitrate"></div>\n  ');
                __line = 15;
            }
            __append("\n\n  ");
            __line = 17;
            if (locals.level.showChunkSizeControl) {
                __append('\n    <h1>Chunk size</h1>\n    <div class="chunk-size"></div>\n  ');
                __line = 20;
            }
            __append("\n\n  ");
            __line = 22;
            if (locals.level.showEncodingControls.length > 0) {
                __append('\n    <div class="encoding"></div>\n  ');
                __line = 24;
            }
            __append("\n\n</div>\n");
            __line = 27;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}